import type { TokenPair } from './schemas/auth'

const KEYS = {
  access: 'kv.access_token',
  refresh: 'kv.refresh_token',
  expiresAt: 'kv.expires_at',
} as const

const read = (key: string): string | null => {
  try {
    return localStorage.getItem(key)
  } catch {
    return null
  }
}

const write = (key: string, value: string | null) => {
  try {
    if (value === null) localStorage.removeItem(key)
    else localStorage.setItem(key, value)
  } catch {
    /* приватный режим или отключённое хранилище — работаем без персистентности */
  }
}

export const tokenStorage = {
  getAccess: () => read(KEYS.access),
  getRefresh: () => read(KEYS.refresh),
  /** Момент истечения access-токена, мс epoch. 0 — неизвестно. */
  getExpiresAt: () => Number(read(KEYS.expiresAt) ?? 0),
  set(tokens: TokenPair) {
    write(KEYS.access, tokens.access_token)
    write(KEYS.refresh, tokens.refresh_token)
    write(KEYS.expiresAt, String(Date.now() + tokens.expires_in * 1000))
  },
  clear() {
    write(KEYS.access, null)
    write(KEYS.refresh, null)
    write(KEYS.expiresAt, null)
  },
}
